/* Regular-tee photo views in the browser: one canvas per TeePhotoMaterial view.
   The print's placement is the classic editor's (ClassicRenderer.placement on the
   classic print area), normalised into each photo's print rectangle, so what the
   customer drags on the hero is what every photo shows. Layers are theme assets
   (window.TeePhotoAssets, from the section); the artwork comes through the aiapi
   design-image proxy because GCS sends no CORS. */
(function () {
  'use strict'
  var engine = window.TeePhotoRenderer, material = window.TeePhotoMaterial, N = engine.size
  var classic = window.ClassicRenderer, garments = window.ClassicMaterial
  var cache = { material: {}, art: {}, ink: {} }
  var PROXY = 'https://aiapi.macmerise.com/api/design-image?file='
  var GCS = 'https://storage.googleapis.com/ai-customizer-v2/designs/'
  var CDN = 'https://cdn.macmerise.com/customiser/designs/'
  // Design pixels go through the API proxy: Front Door caches the CDN copy without CORS headers when a plain <img> fetched it first, and a canvas cannot read it.
  var viaProxy = function (url) { var base = url.indexOf(CDN) === 0 ? CDN : url.indexOf(GCS) === 0 ? GCS : null; return base ? PROXY + encodeURIComponent(url.slice(base.length)) : url }

  function asset(name) { var a = window.TeePhotoAssets; if (!a || !a[name]) throw new Error('Missing tee photo asset ' + name); return a[name] }
  function canvas() { var c = document.createElement('canvas'); c.width = c.height = N; return c }
  function context(c) { return c.getContext('2d', { willReadFrequently: true }) }
  function image(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image(); img.crossOrigin = 'anonymous'
      img.onload = function () { resolve(img) }; img.onerror = function () { reject(new Error('Could not load ' + url)) }
      img.src = url
    })
  }
  // Coordinate maps and masks must arrive lossless: the Shopify CDN serves a lossy
  // WebP to browsers that accept it (Vary: Accept), which shifts values by a few
  // units and ripples the warp. Ask for the PNG bytes and decode them ourselves.
  function exact(url) {
    return fetch(url, { headers: { Accept: 'image/png' } }).then(function (r) { if (!r.ok) throw new Error('Could not load ' + url); return r.blob() })
      .then(function (blob) { return new Promise(function (resolve, reject) {
        var u = URL.createObjectURL(blob), img = new Image()
        img.onload = function () { URL.revokeObjectURL(u); resolve(img) }
        img.onerror = function () { URL.revokeObjectURL(u); reject(new Error('Could not decode ' + url)) }
        img.src = u
      }) })
  }
  function pixels(img, w, h) { var c = document.createElement('canvas'); c.width = w || img.naturalWidth; c.height = h || img.naturalHeight; var g = context(c); g.drawImage(img, 0, 0, c.width, c.height); return g.getImageData(0, 0, c.width, c.height) }
  function cached(store, key, load) { if (!store[key]) store[key] = load().catch(function (e) { delete store[key]; throw e }); return store[key] }

  function layers(view) {
    return cached(cache.material, view.id, function () {
      var names = ['source.jpg', 'mask.png', 'displacement.png']; if (view.bottoms) names.push('bottoms.png')
      return Promise.all(names.map(function (n) { return (/\.png$/.test(n) ? exact : image)(asset('tee-photo-' + view.id + '-' + n)).then(function (img) { return pixels(img, N, N) }) }))
        .then(function (parts) { return engine.prepare(view, parts[0], parts[1], parts[2], parts[3] || null) })
    })
  }
  var art = function (url) { return cached(cache.art, url, function () { return image(viaProxy(url)).then(function (img) { return pixels(img) }) }) }

  // Where the artwork sits inside the print rectangle, 0..1, from the classic editor's transform.
  function placement(side, artData, transform) {
    var area = garments.variants['regular-' + side].area, box = classic.placement(artData.width, artData.height, transform || {}, area)
    return { ox: (box.x - area.x) / area.width, oy: (box.y - area.y) / area.height, aw: box.width / area.width, ah: box.height / area.height }
  }

  function inkFor(view, mat, design, white) {
    if (!view.print || !design || !design.url) return Promise.resolve(null)
    return art(design.url).then(function (artData) {
      // One warped layer per view (4.6 MB each): a drag produces many placements, so only the latest is kept.
      var place = placement(view.side, artData, design.transform), key = design.url + '|' + JSON.stringify(place), slot = cache.ink[view.id]
      if (!slot || slot.key !== key) slot = cache.ink[view.id] = { key: key, layer: engine.ink(mat, artData, place, white) }
      return slot.layer
    })
  }

  /**
   * @param {Element} container - holds one canvas[data-view] per view
   * @param {Function} getState - () => { colour, front: {url, transform}|null, back: {url, transform}|null }
   */
  function mount(container, getState) {
    var token = 0, frame = 0, disposed = false
    var canvases = Array.prototype.slice.call(container.querySelectorAll('canvas[data-view]'))
    canvases.forEach(function (c) { c.width = c.height = N })
    var palette = garments.variants['regular-front'].palette, white = classic.find(palette, 'White').target.rgb
    // Paint what is on screen first; the rest follows in the gaps.
    function ordered() {
      var h = window.innerHeight
      return canvases.slice().sort(function (a, b) {
        var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect()
        var va = ra.bottom > 0 && ra.top < h && ra.right > 0 && ra.left < window.innerWidth, vb = rb.bottom > 0 && rb.top < h && rb.right > 0 && rb.left < window.innerWidth
        return (vb ? 1 : 0) - (va ? 1 : 0)
      })
    }
    async function draw() {
      var run = ++token, state = getState(), colour = classic.find(palette, state.colour)
      if (!colour) throw new Error('Unsupported garment colour')
      var list = ordered()
      for (var i = 0; i < list.length; i++) {
        if (run !== token || disposed) return false
        var view = material.views.find(function (v) { return v.id === list[i].dataset.view })
        var mat = await layers(view)
        var ink = await inkFor(view, mat, view.side === 'back' ? state.back : view.side === 'front' ? state.front : null, white)
        if (run !== token || disposed) return false
        var out = engine.paint(mat, colour.target, ink)
        list[i].getContext('2d').putImageData(new ImageData(out, N, N), 0, 0)
        list[i].dataset.ready = 'true'
        await new Promise(function (r) { setTimeout(r, 0) })
      }
      container.dataset.ready = 'true'
      return true
    }
    function update() { cancelAnimationFrame(frame); frame = requestAnimationFrame(function () { draw().catch(function (e) { container.dataset.error = e.message; console.error('Photo views:', e) }) }) }
    update()
    return { update: update, destroy: function () { disposed = true; cancelAnimationFrame(frame) } }
  }

  window.TeePhotoBrowser = { mount: mount }
})()
